import './App.css';
import { Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar';
import Home from './pages/Home'
import AboutUs from './pages/Aboutus';
import Footer from './components/Footer';
import Quiz from './pages/quiz';
import Programmes from './pages/Programs';
import ContactInfo from './pages/Contactus';
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  return (
    <>
    <Navbar />

    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/about' element={<AboutUs />} />
      <Route path='/quiz' element={<Quiz />} />
      <Route path='/program' element={<Programmes />} />
      <Route path='/contact' element={<ContactInfo />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 

    </Routes> 

    <Footer />  
    </>
  );
}

export default App;
